import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import './BooleanIndication.less'

export default class BooleanIndication extends React.Component {
  render () {
    const classesObject = {
      'nmc-boolean-indication': true,
      'nmc-boolean-indication-active': !!this.props.active
    }
    return (
      <div className={classNames(classesObject)} />
    )
  }
}

BooleanIndication.propTypes = {
  isActive: PropTypes.bool
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/BooleanIndication/index.js